import { useParams } from "react-router-dom";
import CustomForm from '../../../core/components/core/Util/Form/CustomForm/CustomForm';
import CustomFormContainer from '../../../core/components/core/Util/Form/CustomForm/CustomFormContainer';
import config from '../../config/config';
import Fetch from '../../../core/util/core/Fetch';
import { useEffect, useState } from 'react';

function Form() {
    const { id } = useParams();
    const [form, setForm] = useState();
    const [formContent, setFormContent] = useState(<>Carregando...</>);

    const endpointBackend = config.endpoints.backend;

    const paths = {
        endpointSave: `${endpointBackend}gci/project-types-third-sector/save`,
        endpointGetById: `${endpointBackend}gci/project-types-third-sector/getById`,
        urlGoBack: `/gci/project-types-third-sector/list`,
        pathView: `/gci/project-types-third-sector/view`
    }

    const labels = {
        labelTitleAdd: "Novo Tipo de Projeto Terceiro Setor",
        labelTitleEdit: "Editar Tipo de Projeto Terceiro Setor",
        labelTitleView: 'Visualizar Tipo de Projeto Terceiro Setor'
    }

    const getForm = (values) => {

        let form = {
            fields: [
                {
                    name: 'project_type',
                    type: 'text',
                    label: 'Tipo de Projeto',
                    validations: {
                        required: true
                    },
                    columnSize: 12,
                },
            ],
            ...paths,
            ...labels,
        }
        form.values = values;
        return form;
    }

    useEffect(() => {
        const load = async () => {
            let values = {};
            if (id) {
                values = await Fetch.post(paths.endpointGetById, { id: id })
            }

            const form = getForm(values);

            setForm(form);
            setFormContent(
                <CustomFormContainer
                    form={form}
                    content={<CustomForm form={form} />} />
            );
        }
        load();
    }, [])

    return (
        <div>
            {formContent}
        </div>
    );
}
export default Form;
